<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen" >
		<div class="head head-with-brand big">
			<div class="container">
				<div class="btn icon icon-close invert" @click="cancelControl"></div>
				<small>CHASSIS</small>
				<h1>{{control.car.chassis_number}}</h1>
				<h2>{{control.car.brand.title}} {{control.car.model}}</h2>
				<div class="brand" v-if="control.car.brand.logo" :style="{backgroundImage:`url(${API_URL+control.car.brand.logo.urlThumb})`}"></div>
			</div>
		</div>
		
		<div class="content">
			<div class="container">

				<div class="text-center">
					<h1 class="mt-1 mb-1">Ingrese la nueva ubicación del vehículo</h1>
					<img :src="require('@/assets/icons/icon-parking-lot.png')">
				</div>
				
				<ParkingSlotInput 
					v-model="newParkingSlot" 
					:carId="control.car.id"
					ref="parkingSlot"
					></ParkingSlotInput>

				<div class="invalid-feedback d-block" v-if="validation.hasError('newParkingSlot.id')">Compruebe la disponibilidad para continuar</div>

			</div>
		</div>
		<div class="footer">
			<div class="container">
				<div class="btn btn-block btn-primary" @click="nextStep()">
					Continuar
				</div>
			</div>
		</div>
	</div>
	
	<ControlSuccess 
		v-if="control.step=='ControlSuccess'"
		:control="controlCreated"
	></ControlSuccess>

</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'
import ParkingSlotInput from '@/components/ParkingSlotInput'
import ControlSuccess from '@/views/controls/ControlSuccess'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'CarToMove',
	mixins:[mixins],
	components: {
		Loader,
		ParkingSlotInput,
		ControlSuccess
	},
	data(){
		return{
			API_URL: process.env.VUE_APP_API_URL,
			loading: false,
			controlCreated: null,
			newParkingSlot: null
		}
	},
	computed: {
		...mapState(['control'])
	},
	validators: {
		'newParkingSlot.id': function (value) {
			return Validator.value(value).required();
		},
	},
	methods:{
		...mapMutations(['saveControl','deleteControl']),
		cancelControl(){
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		},
		nextStep () {
			if( this.control.step == 'main' ) {
				this.finishControl()
				return
			}
		},
		async checkAvailability(){
			await this.$refs.parkingSlot.find()
			this.finishControl()
		},
		async finishControl(){

			if(!this.loading && await this.checkValidation() ) {
				this.$dialog
				.confirm('Confirmar cambio de lugar',{
					cancelText: 'Cancelar',
					okText: 'Confirmar'
				})
				.then(() => {
					this.finishControlOK()
				})
			}
		},
		async finishControlOK(){
			
			this.loading = true
			let dataInput = {
				car_id 			: this.control.car.id,
				parking_slot_id	: this.newParkingSlot.id 
			}
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:ControlMoveCarInput! ){
					controlMoveCar( data: $data) {
						id
						car{
							id
						}
						user{
							name
						}
						type
						typeText
						lubricants{
							lubricant{
								title
							}
							liters
						}
						labor_hours
						polished
						polished_pieces
						gas_charge
						has_damages
						comments
						files{
							id
							url
							urlThumb
						}
						damages{
							side
							images{
								urlThumb
							}
							position{
								top
								left
							}
							type
							typeText
							description
							status
						}
						missings{
							description
						}
						truck_mat
						truck_driver_name
						truck_driver_signature

						created_at
					}
				}`,
				variables: {
					data: dataInput
				}
			})
			.then((data) => {
				this.controlCreated = data.data.controlMoveCar
				this.loading = false
				this.control.step = 'ControlSuccess'
			})
			.catch( (error) => {
				this.parseGQLErrors(error)
				this.loading = false
			})
		}
	}
	
}
</script>

<style scoped lang="scss">

</style>
